import { FormGroup } from '@angular/forms';
import dayjs, { Dayjs } from 'dayjs';
import { KeyValue } from './contracts/key-value';

export function combineUrl(...urlParts: unknown[]): string {
  return urlParts.map(u => '' + u)
    .reduce((p, c) => (!p || p.endsWith('/') ? p : p + '/') + (c.startsWith('/') ? c.substr(1, c.length - 1) : c), '');
}

export function isNullOrEmpty(value: unknown): boolean {
  return typeof value === 'undefined' || value === null || value === '';
}

export function jsonToString(json: KeyValue): string {
  if (!json) {
    return null;
  }
  const str = JSON.stringify(json);
  return str && str != '{}' ? str : null;
}

export function NOOP(value?: unknown): void { }

export function compact<T>(object: T): T {
  if (object) {
    Object.keys(object)
      .forEach(key => {
        if (isNullOrEmpty(object[key])) {
          delete object[key];
        }
      });
  }
  return object;
}

export function compactArray(arr: any[]): any[] {
  return arr.filter(t => !isNullOrEmpty(t));
}

export function isEmptyArray(arr: any[]): boolean {
  return arr.every(t => isNullOrEmpty(t));
}

export function resetForm(form: FormGroup, object: KeyValue, options?: { onlySelf?: boolean; emitEvent?: boolean }): void {
  const formValues: KeyValue = {};
  Object.keys(form.controls).forEach(key => {
    formValues[key] = !isNullOrEmpty(object[key]) ? object[key] : null;
  });
  form.reset(formValues, options);
}

export function toNumArray(value: string | number | string[] | null): number[] | null {
  if (isNullOrEmpty(value)) {
    return null;
  }
  if (Array.isArray(value)) {
    return value.map(t => +t);
  }
  return [+value];
}

export function formatDate(value: Date | Dayjs): string | null {
  return value ? dayjs(value).format('YYYY-MM-DD') : null;
}

export function dateToNumber(value: Date | Dayjs): number | null {
  return value ? +dayjs(value).format('YYYYMMDD') : null;
}

export function numberToDate(value?: number): Date | null {
  return value ? dayjs.utc(String(value), 'YYYYMMDD').toDate() : null;
}

export function toStringArray(value: string | string[] | null): string[] | null {
  if (isNullOrEmpty(value)) {
    return null;
  }
  if (Array.isArray(value)) {
    return value;
  }
  return [value];
}
